import { useState } from "react";
import { Modal } from "../../components/Modal.tsx";
import { ActionButton } from "../../components/ActionButton.tsx";
import { showNotification } from "../../util/showNotification.ts";
import type { View } from "../../../common/types.ts";
import { toWorker } from "../../util/toWorker.ts";
import { focusOnMount } from "../../util/refCallbacks.ts";

export const RegenerateScheduleModal = ({
	onCancel,
	onRegenerated,
	show,
}: {
	onCancel: () => void;
	onRegenerated: (schedule: View<"scheduleEditor">["schedule"]) => void;
	show: boolean;
}) => {
	const [regeneratingSchedule, setRegeneratingSchedule] = useState(false);

	const onSubmit = async () => {
		setRegeneratingSchedule(true);

		try {
			const schedule = await toWorker("main", "regenerateSchedule", undefined);
			onRegenerated(schedule);
		} catch (error) {
			showNotification({
				type: "error",
				text: error.message,
			});
		} finally {
			setRegeneratingSchedule(false);
		}
	};

	return (
		<Modal show={show} onHide={onCancel}>
			<Modal.Body>Are you sure you want to regenerate the schedule?</Modal.Body>
			<Modal.Footer>
				<button
					className="btn btn-secondary"
					disabled={regeneratingSchedule}
					onClick={onCancel}
				>
					Cancel
				</button>
				<ActionButton
					onClick={onSubmit}
					processing={regeneratingSchedule}
					processingText="Generating"
					ref={focusOnMount}
					variant="primary"
				>
					Regenerate schedule
				</ActionButton>
			</Modal.Footer>
		</Modal>
	);
};
